import React from 'react';
import Tooltip from '@mui/material/Tooltip';

// Narrow header for the icon column that opens an opportunity in Salesforce; the tooltip says what the icon does
// (and, where the name is a link, where that goes) so the column costs two letters of width, not a legend row.
export default function SfColumnHeader({ nameOpensDeal = false }) {
  const title = nameOpensDeal
    ? 'Icon: open in Salesforce. Opportunity name: open our deal page.'
    : 'Icon: open in Salesforce.';
  return (
    <Tooltip title={title} arrow>
      <span style={{ cursor: 'help', borderBottom: '1px dotted currentColor' }} data-testid="sf-column-header">SF</span>
    </Tooltip>
  );
}
